import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Connects to data-controller="title-upload"
// Drag-and-drop or file picker for a multi-page title PDF.
// Stashes the File on window.titlePdfFile, then navigates to the assignment page.
//
// Usage:
//   <div data-controller="title-upload"
//        data-title-upload-url-value="/purchases/1/title_assignment"
//        data-action="dragenter->title-upload#dragEnter
//                     dragover->title-upload#dragOver
//                     dragleave->title-upload#dragLeave
//                     drop->title-upload#drop">
//     <div data-title-upload-target="overlay" class="hidden ...">Drop PDF here</div>
//     <input type="file" data-title-upload-target="fileInput" ...>
//   </div>
export default class extends Controller {
  static targets = ["fileInput", "overlay"]
  static values = { url: String }

  connect() {
    this.dragCounter = 0
  }

  dragEnter(event) {
    event.preventDefault()
    this.dragCounter++
    if (this.dragCounter === 1) {
      this.showOverlay()
    }
  }

  dragOver(event) {
    event.preventDefault()
  }

  dragLeave(event) {
    event.preventDefault()
    this.dragCounter--
    if (this.dragCounter === 0) {
      this.hideOverlay()
    }
  }

  drop(event) {
    event.preventDefault()
    this.dragCounter = 0
    this.hideOverlay()

    const files = Array.from(event.dataTransfer.files)
    if (files.length === 0) return

    this.processFile(files[0])
  }

  browse() {
    this.fileInputTarget.click()
  }

  fileSelected() {
    const file = this.fileInputTarget.files[0]
    if (!file) return

    this.processFile(file)
    this.fileInputTarget.value = ""
  }

  processFile(file) {
    if (file.type !== "application/pdf") {
      this.showToast("error", "Please select a PDF file.")
      return
    }

    const maxSize = 25 * 1024 * 1024 // 25MB
    if (file.size > maxSize) {
      this.showToast("error", "File is too large. Maximum size is 25MB.")
      return
    }

    window.titlePdfFile = file
    Turbo.visit(this.urlValue)
  }

  showOverlay() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("flex")
  }

  hideOverlay() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.add("hidden")
    this.overlayTarget.classList.remove("flex")
  }

  showToast(type, message) {
    document.dispatchEvent(new CustomEvent("toast:show", {
      detail: { type, message }
    }))
  }
}
